import { useTranslation } from "react-i18next";

import { Dialog, Button } from "@mui/material";

import { Container, Content, ContentText } from "./styles";
import React, { useState } from "react";
import DialogTitle from "../../../../containers/DialogTitle/DialogTitle";
import DialogActions from "../../../../containers/DialogActions/DialogActions";
import LoadingOverlay from "../../../../containers/LoadingOverlay/LoadingOverlay";
import { TnATimesheetConfirmationSTO } from "../../../../models/tna-timesheet-confirmation";
import { intlFormatDateShort } from "../../../../utils/time-utils";
import { CustomDate } from "../../../../models/custom-date/custom-date";

export enum DialogOptions {
  remind = "remind",
  cancel = "cancel",
}

interface Props {
  sendRequest: (item: TnATimesheetConfirmationSTO) => void;
  children?: React.ReactNode;
  item: TnATimesheetConfirmationSTO;
  disabled?: boolean;
  option: DialogOptions;
}

const ConfirmationDialog = ({ sendRequest, children, item, disabled, option }: Props) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSendRequest = async () => {
    setLoading(true);
    await sendRequest(item);
    setLoading(false);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Container onClick={() => !disabled && setOpen(true)}>{children}</Container>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <LoadingOverlay loading={loading}>
          <DialogTitle
            title={option === DialogOptions.remind ? `Remind sign-off` : "Cancel sign-off"}
            handleClose={handleClose}
          />
          <Content>
            {option === DialogOptions.remind && (
              <ContentText>{`Do you want to send a sign-off reminder to ${item.employee?.name}?`}</ContentText>
            )}

            {option === DialogOptions.cancel && (
              <ContentText>{`Are you sure you want to cancel a sign-off request as of ${
                !!item.asOfDate ? intlFormatDateShort(CustomDate.ToDate(item.asOfDate) ?? new Date()) : ""
              } to ${item.employee?.name}?`}</ContentText>
            )}
          </Content>
          <DialogActions
            handleCancel={handleClose}
            useGoback
          >
            <Button
              onClick={handleSendRequest}
              variant="contained"
            >
              {`Send`}
            </Button>
          </DialogActions>
        </LoadingOverlay>
      </Dialog>
    </>
  );
};

export default ConfirmationDialog;
